"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const RedirectDialog = ({ close, linkToRedirect, setStorage, acceptButtonLabel, declineButtonLabel, }) => {
    const handleClickOnRedirect = React.useCallback(() => {
        setStorage(linkToRedirect, 'YES');
        window.location.href = linkToRedirect;
    }, [linkToRedirect, setStorage]);
    const handleClickOnStayOnGlobal = React.useCallback(() => {
        setStorage(linkToRedirect, 'NO');
        close();
    }, [close, linkToRedirect, setStorage]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-2xs w-full sm:w-auto flex-col sm:flex-row", "data-testid": "redirectDialog", children: [(0, jsx_runtime_1.jsx)("button", { className: "btn-secondary", onClick: handleClickOnStayOnGlobal, children: declineButtonLabel }), (0, jsx_runtime_1.jsx)("button", { className: "btn-primary", onClick: handleClickOnRedirect, children: acceptButtonLabel })] }));
};
exports.RedirectDialog = RedirectDialog;
